export default __webpack_public_path__ + "static/media/dci.cb1d42dc.png";